exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tox-fullscreen .tox.tox-tinymce.tox-fullscreen{z-index:1040!important}", ""]);

// exports
